<nav class="navbar navbar-expand-md navbar-custom mx-auto">
  <div class="container-fluid w-100">
    <a href="http://fotiou.afsdynamics.net/" class="navbar-brand">
      <img src="../../../../../assets/images/logo.png" class="d-inline-block align-center navbar-image" alt="">
    </a>

    <button class="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#navbarCustom">
      <i class="fa fa-bars fa-lg py-1 text-dark"></i>
    </button>
    <div class="navbar-collapse collapse" id="navbarCustom">      
      <ul class="navbar-nav ml-auto">
        <li class="nav-item my-auto pr-4" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link link-icon btn btn-danger text-white py-2 px-3 d-inline-block mr-2" href="https://www.facebook.com/fotiouframes" target="_blank"><i class="fa fa-facebook"></i></a>
          <a class="nav-link link-icon btn btn-danger text-white py-2 px-3 d-inline-block mr-2" href="https://twitter.com/fotiouframes" target="_blank"><i class="fa fa-twitter"></i></a>
          <a class="nav-link link-icon btn btn-danger text-white py-2 px-3 d-inline-block mr-2" href="https://ca.linkedin.com/pub/fotiou-frames/73/757/953" target="_blank"><i class="fa fa-linkedin-square"></i></a>
          <a class="nav-link link-icon btn btn-danger text-white py-2 px-3 d-inline-block mr-2" href="http://instagram.com/fotiouframes" target="_blank"><i class="fa fa-instagram"></i></a>
          <a class="nav-link link-icon btn btn-danger text-white py-2 px-3 d-inline-block mr-2" href="https://www.pinterest.ph/fotiouframes/" target="_blank"><i class="fa fa-pinterest"></i></a>
        </li>
        <!--<li class="nav-item my-auto" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link"><img src="../../../../../assets/images/flag.PNG" /></a>
        </li>-->

        <ng-container *ngIf="isLoggedIn">
          <li class="nav-item my-auto" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <a class="nav-link"routerLink="/orders/sample">Sample Order</a>
          </li>
          <li class="nav-item my-auto" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"> 
            <a class="nav-link" routerLink="/orders/quick">Quick Order</a>
          </li>
          <li class="nav-item my-auto" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <a class="nav-link" routerLink="/quotes/create">Create Quotation</a>
          </li>
          <li class="nav-item my-auto" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <!--<i class="fa fa-star fa-lg text-dark"></i>-->
            <a class="nav-link" routerLink="/favorites">Fotiou Favorites</a>
          </li>
        </ng-container>

        <li class="nav-item my-auto border-none" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="!_authService.getLoggedInUser()">
          <a class="nav-link" routerLink="/auth/login">Sign In</a>
        </li>
        <!--<li class="nav-item my-auto" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="_authService.getLoggedInUser()">
          <a class="nav-link" (click)="_navService.logout()">Sign Out</a>
        </li>-->
        <li class="border-none pl-3" *ngIf="_authService.getLoggedInUser()">
          <a class="nav-link mr-3 mr-lg-1 py-0 px-0 mt-1" [matMenuTriggerFor]="menu">

            <!--LOGO HERE-->
            <app-image-circle [height]="40" [width]="40" [hasBorder]="true" [imageSrc]="_navService.imageUrl"></app-image-circle>
          </a>

          <mat-menu #menu="matMenu" xPosition="before">
            <ng-container>
              <a mat-menu-item routerLink="/admin/dashboard">
                My Account
              </a>              
              <a mat-menu-item (click)="_navService.logout()">
                Sign Out
              </a>
            </ng-container>            
          </mat-menu>
        </li>
        <li class="border-none" *ngIf="_authService.getLoggedInUser()">
          <a class="nav-link mr-3 mr-lg-0 py-0 px-0" (click)="openModal()">
            <span class="fa-stack " style="vertical-align: top;">
              <i class="fa fa-circle fa-stack-2x text-light"></i>
              <i class="fa fa-shopping-cart fa-stack-1x text-danger"></i>
              <span class="badge badge-pill badge-dark" *ngIf="_notificationService.count > 0">{{_notificationService.count}}</span>
            </span>

          </a>
        </li>       
      </ul>
    </div>
  </div>
</nav>
<nav class="navbar navbar-expand-lg navbar-light navbar-custom2 mx-auto">
  <div class="navbar-collapse collapse">
    <ul class="navbar-nav">
      <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <!-- <a class="nav-link" routerLink="/home">HOME</a> -->
        <a class="nav-link" href="http://fotiou.afsdynamics.net/">HOME</a>
      </li>
      <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <!-- <a class="nav-link" routerLink="/aboutus">ABOUT US</a> -->
        <a class="nav-link" href="http://fotiou.afsdynamics.net/about/">ABOUT US</a>
      </li>
      <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a class="nav-link" href="http://fotiou.afsdynamics.net/shop/">SHOP</a>
      </li>
      <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a class="nav-link" routerLink="/product">PRODUCTS</a>
      </li>
      <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a class="nav-link">NEW ARRIVALS</a>
      </li>
      <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a class="nav-link">FIND A DEALER</a>
      </li>
      <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a class="nav-link" href="http://fotiou.afsdynamics.net/contact/">CONTACT US</a>
      </li>      
    </ul>
    <!-- <form class="form-inline my-2 my-lg-0 pull-right search-form">
      <input class="form-control" style="width:200px" type="text" placeholder="">
      <button class="btn btn-danger my-2 my-sm-0" type="submit">
        <i class="fa fa-search"></i>
      </button>
    </form> -->
  </div>
</nav>
